const U2F = [
    {name: 'serial', placeholder:'Device Name'},
    {name: 'registrationEmail', placeholder:'Email Address'}
];

const YOTP = [
    {name: 'serial', placeholder:'Decimal'},
    {name: 'publicIdentity', placeholder:'1-16 Bytes Modhex' , charSet: '0-9a-zA-Z', pattern: '[0-9a-zA-Z]{12}', maxLength: 120},
    {name: 'privateIdentity', placeholder:'6 Bytes Hex' , charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{12}', maxLength: 120},
    {name: 'secret', placeholder:'16 Bytes Hex' , charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{32}', maxLength: 320}
];

const HOTP = [
    {name: 'serial', placeholder:'Decimal'},
    {name: 'secret', placeholder:'20 Bytes Hex', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{16,256}', maxLength: 512}
];

const THIRD_PARTY = [
    {name: 'serial', placeholder:'Hexadecimal'},
    {name: 'secret', placeholder:'Hexadecimal', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{16,256}', maxLength: 512}
];

export const props = {
    YUBIKey_USB_KEY: {
        U2F,
        YOTP,
        HOTP
    },
    THIRD_PARTY: {
        TOTP: THIRD_PARTY,
        HOTP: THIRD_PARTY
    }
};



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-integration-properties.js